var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _stop, _stop2, _stop3, _stop4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleSlidesIcon = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 100,
    fill: "none",
    viewBox: "0 0 73 100"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__a",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B400",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894L56.03 15.688z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__b",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__b)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M50.426 44.823H21.291a3.37 3.37 0 0 0-3.362 3.362V77.32a3.37 3.37 0 0 0 3.362 3.362h29.135a3.37 3.37 0 0 0 3.362-3.362V48.185a3.37 3.37 0 0 0-3.362-3.362m-1.12 25.774H22.412V54.909h26.894z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__c",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "google-slides-icon_svg__d)",
    d: "M46.79 24.927 71.717 49.85V26.894z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__e",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__e)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADA80",
    d: "M44.823 0v20.17a6.72 6.72 0 0 0 6.724 6.724h20.17z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__f",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__f)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M44.823 0v.56l26.334 26.334h.56z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__g",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__g)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M6.723 0C3.026 0 0 3.026 0 6.723v.56C0 3.587 3.026.56 6.723.56h38.1V0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__h",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__h)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF360C",
    fillOpacity: 0.2,
    d: "M64.994 98.05H6.724C3.025 98.05 0 95.026 0 91.328v.56c0 3.698 3.026 6.724 6.723 6.724h58.27c3.699 0 6.724-3.026 6.724-6.723v-.56c0 3.697-3.025 6.723-6.723 6.723"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: _uid + "google-slides-icon_svg__i",
    width: 72,
    height: 99,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#" + _uid + "google-slides-icon_svg__i)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF360C",
    fillOpacity: 0.1,
    d: "M51.547 26.894a6.72 6.72 0 0 1-6.724-6.723v.56a6.72 6.72 0 0 0 6.724 6.723h20.17v-.56z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "google-slides-icon_svg__j)",
    d: "M44.823 0h-38.1C3.026 0 0 3.026 0 6.723v85.165c0 3.697 3.026 6.723 6.723 6.723h58.27c3.699 0 6.724-3.026 6.724-6.723V26.894z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _uid + "google-slides-icon_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(2.272 1.96)scale(115.643)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "google-slides-icon_svg__d",
    x1: 59.255,
    x2: 59.255,
    y1: 27.067,
    y2: 49.852,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })))));
};
export { SvgGoogleSlidesIcon as ReactComponent };
export default __webpack_public_path__ + "00c78534f2ef4ea615856e47c3243665.svg";